import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ServiceContractRythm } from '@work4all/models/lib/Enums/ServiceContractRythm.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function RythmPicker<TMultiple extends boolean>(
  props: Props<TMultiple>
) {
  const { t } = useTranslation();

  let searchTimeout = null;

  const [searchText, setSearchText] = useState<string>('');

  const dataset = useMemo(
    () =>
      Object.keys(ServiceContractRythm)
        .map((key) => {
          const id = ServiceContractRythm[key];

          return {
            id,
            name: t(`SERVICECONTRACT.RYTHMSTATUSES.${id}`),
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter(
          (value) =>
            !searchText ||
            value.name
              .toLocaleLowerCase()
              .includes(searchText.toLocaleLowerCase())
        ),
    [t, searchText]
  );

  return (
    <FixedDataPicker
      dataSet={dataset}
      {...props}
      layout={props.layout ?? 'simple'}
      onSearchValueChange={(newSearchText) => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          setSearchText((newSearchText || '').trim());
        }, 200);
      }}
    />
  );
}
